import script from "./CaseStudiesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudiesSection.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudiesSection.vue?vue&type=style&index=0&id=418c1ff3&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418c1ff3"]])

export default __exports__